document.addEventListener('DOMContentLoaded', function (){

    let personalizationTextBlock, personalizationText;

    const personalizationTriggerOptions = [
        'engraving',
        'personalization'
    ];

    const personalizationTriggerValues = [
        'engrave monogram',
        'engrave logo',
        'engrave qr-code',
        'plain embossing',
        'silver embossing',
        'gold embossing'
    ];

    // personalization on product page
    if (document.querySelector('.product-section .personalization-info')){
        setPersonalization();
    }

    if (document.querySelector('.product-section')){
        selectionOptionListener();
        showSelectedOptionValue();
        setMaxProductDescription();
    }

    function setPersonalization(){
        personalizationTextBlock = document.querySelector('.personalization-info');
        personalizationText = document.querySelector('#personalization-info');
        let productOptions = document.querySelectorAll('.product-form__controls');

        productOptions.forEach(function (item){
            let optionLabel = item.querySelector('.product-form__group-label').textContent;

            if (personalizationTriggerOptions.includes(optionLabel.toLowerCase())) {
                let currentSelected = item.querySelector('input[type="radio"]:checked');
                let optionSelects = item.querySelectorAll(`input[type="radio"][name="${optionLabel}"]`);

                if (personalizationTriggerValues.includes(currentSelected.value.toLowerCase())) {
                    personalizationTextBlock.classList.add('active');
                }

                personalizationListener(optionSelects);
            } else {
                // listen another option
                let optionSelects = item.querySelectorAll(`input[type="radio"][name="${optionLabel}"]`);
                listenAnotherOption(optionSelects);
            }
        })
    }

    function listenAnotherOption(optionSelects) {
        optionSelects.forEach(function (item){
            item.addEventListener('change', function (){
                setTimeout(function (){
                    checkPersonalizationField();
                }, 100);
            })
        })
    }

    // listen change size option
    function personalizationListener(optionSelects){
        optionSelects.forEach(function (item){
            item.addEventListener('change', function (event){
                if (personalizationTriggerValues.includes(event.target.value.toLowerCase())) {
                    personalizationTextBlock.classList.add('active');
                } else {
                    personalizationTextBlock.classList.remove('active');
                    document.getElementById('personalization-text-hidden').value = '';
                    document.getElementById('personalization-info').value = '';
                }

                setTimeout(function (){
                    checkPersonalizationField();
                }, 100);
            })
        })

        // Listen personalizationText
        personalizationText.addEventListener('input', function (event) {
            checkPersonalizationField();
            document.getElementById('personalization-text-hidden').value = this.value;
        });

        checkPersonalizationField();
    }

    function isEmptyPersonalizationField() {
        if (personalizationText.value.length < 2) {
            return true;
        } else {
            return false;
        }
    }

    // disable button if field empty
    function checkPersonalizationField() {
        let buttons = document.querySelectorAll('.product-form__buttons button');

        setTimeout(function (){
            if (personalizationTextBlock.classList.contains('active')) {
                if (isEmptyPersonalizationField()) {
                    buttons.forEach(function (item){
                        item.setAttribute('disabled', 'disabled');
                        personalizationTextBlock.classList.add('error');
                    })
                } else {
                    buttons.forEach(function (item){
                        item.removeAttribute('disabled');
                        personalizationTextBlock.classList.remove('error');
                    })
                }
            }
        },600)
    }

    function selectionOptionListener() {
        let optionValueRadios = document.querySelectorAll('variant-radios input[type="radio"]');

        optionValueRadios.forEach(function (item) {
            item.addEventListener('change', function (){
                showSelectedOptionValue();
            })
        })
    }

    function showSelectedOptionValue() {
        let productOptions = document.querySelectorAll('.product-form__controls');

        productOptions.forEach(function (item){
            const showSelectedValueElement = item.querySelector('.product-form__selected-value')

            if (item.querySelector('input[type="radio"]:checked')) {
                const selectedValue = item.querySelector('input[type="radio"]:checked').value;
                showSelectedValueElement.innerText = selectedValue;
            }
        })
    }

    function setMaxProductDescription() {
        const productDescriptionBlock = document.querySelector('.product__description');
        const descriptionButtonHolder = document.querySelector('.product__description-button-holder');
        let showAllLabel, hideAllLabel;

        if (document.querySelector('html').lang === 'uk-UA') {
            showAllLabel = 'Читати повний опис';
            hideAllLabel = 'Приховати';
        } else {
            showAllLabel = 'Читать полное описание';
            hideAllLabel = 'Спрятать';
        }

        if (productDescriptionBlock.scrollHeight > 250) {
            const showMoreButton = document.createElement('button');

            showMoreButton.innerText = showAllLabel;
            showMoreButton.classList.add('product__description-show-more');

            showMoreButton.addEventListener('click', function () {
                productDescriptionBlock.classList.toggle('product__description-hidden');

                if (productDescriptionBlock.classList.contains('product__description-hidden')) {
                    showMoreButton.innerText = showAllLabel;
                } else {
                    showMoreButton.innerText = hideAllLabel;
                }
            });

            descriptionButtonHolder.append(showMoreButton);
            productDescriptionBlock.classList.add('product__description-hidden');
        }
    }

    var currentDomain = window.location.hostname;
    var links = document.querySelectorAll('a[href^="http"]');

    links.forEach(function(link) {
        if (!link.href.includes(currentDomain)) {
            var existingRel = link.getAttribute('rel') || '';
            if (!existingRel.includes('nofollow')) {
                link.setAttribute('rel', (existingRel + ' nofollow').trim());
            }

            if (!link.getAttribute('target')) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', link.getAttribute('rel') + ' noopener noreferrer');
            }
        }
    });
})